module.exports = __webpack_public_path__ + "static/media/CT_2019_30441A_pdf.6d18d646.pdf";